<script setup>
import translate from "@/filters/translate.filter"

import {
  DsTitle,
  DsCell,
  DsIllustration
} from "@ds/vue2"
const parentAdvantages = [
  {
    illustration: 'transfer-gold',
    text: translate('goldkid-advantageAB-parent:advantage-1')
  },
  {
    illustration: 'doc-gold',
    text: translate('goldkid-advantageAB-parent:advantage-2')
  },
  {
    illustration: 'globe-gold',
    text: translate('goldkid-advantageAB-parent:advantage-3')
  }
]
const childAdvantages = [
  {
    illustration: 'phone-gold',
    text: translate('goldkid-advantageAB-child:advantage-1')
  },
  {
    illustration: 'shop-gold',
    text: translate('goldkid-advantageAB-child:advantage-2'),
  },
  {
    illustration: 'transfer-gold',
    text: translate('goldkid-advantageAB-child:advantage-3')
  },
]
</script>

<template>
  <div>
    <DsTitle :text="translate('goldkid-advantageAB-parent:title')" size="h2">
      <span v-html="translate('goldkid-advantageAB-parent:title')" />
    </DsTitle>
    <template v-for="(advantage, index) in parentAdvantages">
      <DsCell :key="index + Math.random() * 1000" :multiline="true" :compact="true">
        <template #left>
          <DsIllustration :name="advantage.illustration" type="dim-icons" />
        </template>
        <template #default>
          <span v-html="advantage.text"></span>
        </template>
      </DsCell>
    </template>

    <DsTitle size="h2">
      <span v-html="translate('goldkid-advantageAB-child:title')" />
    </DsTitle>
    <template v-for="(advantage, index) in childAdvantages">
      <DsCell :key="index + Math.random() * 10" :multiline="true" :compact="true">
        <template #left>
          <DsIllustration :name="advantage.illustration" type="dim-icons" />
        </template>
        <template #default>
          <span v-html="advantage.text"></span>
          <div v-if="advantage.description" class="caption-500 text-text-secondary" v-html="advantage.description"/>
        </template>
      </DsCell>
    </template>
  </div>
</template>